import React from "react";
import type { MyAccountContextState } from "./MyAccount.provider";

export const MyAccountContext = React.createContext(
	{} as MyAccountContextState,
);
